export const addresses = {
  svgHelperAddress: "0xb1CB3D09C4C3878FD8440414C07C3dB085EcBADd",
  splatterAddress: "0x15C40F258B1fc68c109FE3E3CFF191a80f24E4C1",
  splatterArtAddress: "0x9E9e016785b50983Bb2773cE468c479a5D5f64A3",
  splatterToken: "0xfB75Dce8960C4F38b2550c6Eeb0CE40049D242cb",
};
